import React, { Component } from "react";
import { connect } from "react-redux";
import profPlaceholder from "../../../../img/profile-placeholder.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import laborActions from "../../../../_actions/laborActions";
import memoizeOne from "memoize-one";

class LaborDetails extends Component {
  handleClick_verify = (hasLinks) => (e) => {
    e.preventDefault();
    const { toggleVerifyLaborModal, toggleAlert_projLaborHasLinks } = this.props;
    if (hasLinks) toggleAlert_projLaborHasLinks();
    else toggleVerifyLaborModal();
  };

  handleClick_deleteLabor = (e) => {
    e.preventDefault();
    this.props.toggleAlert_deleteLaborConfirm();
  };

  getMergedWithLabor = () => {
    const { laborDetails, projLaborList } = this.props;
    const mergedWith = (projLaborList || []).find(
      (l) => l.laborId === laborDetails.mergedWithLaborId
    );
    return mergedWith ? mergedWith.fullName : "(N/A)";
  };

  render() {
    const { laborDetails, contractorName, trade, handleClick_editLabor, fetching } =
      this.props;

    return (
      <React.Fragment>
        {laborDetails ? (
          <div>
            <span className="h3 card-title ml-0 mr-2 mb-2">{laborDetails.fullName}</span>
            <span
              className={`badge badge-${
                laborDetails.isVerified
                  ? "success"
                  : laborDetails.mergedWithLaborId
                  ? "warning"
                  : "secondary"
              }`}
            >
              {laborDetails.isVerified
                ? "Verified"
                : laborDetails.mergedWithLaborId
                ? "Merged"
                : "Pending"}
            </span>
            <h5 className="card-subtitle text-muted mx-0 mt-1">{laborDetails.trade}</h5>
          </div>
        ) : fetching ? (
          <h5>Loading...</h5>
        ) : (
          <h5 className="text-muted">No labor selected</h5>
        )}
        {laborDetails && (
          <React.Fragment>
            <div className="row mx-0 pl-0 mb-2">
              <div className="col-7 pl-0 pr-1">
                <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                  {laborDetails.mergedWithLaborId && (
                    <li className="list-group-item py-1 pl-1">
                      <div className="row">
                        <div className="col pr-1">
                          <b>Merged With:</b>
                        </div>
                        <div className="col pl-1">{this.getMergedWithLabor()}</div>
                      </div>
                    </li>
                  )}
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Contractor:</b>
                      </div>
                      <div className="col pl-1">{contractorName}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Trade:</b>
                      </div>
                      <div className="col pl-1">{trade}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Phone:</b>
                      </div>
                      <div className="col pl-1">{"xxx-xxx-xxxx"}</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-5 pl-1">
                <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                  <li className="list-group-item py-1 pl-1">
                    <b>Photo:</b>
                    <br />
                    <img
                      src={profPlaceholder}
                      alt="Profile Placeholder"
                      className="profile-photo"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-row form-group">
              {!laborDetails.mergedWithLaborId &&
                (!laborDetails.isVerified ? (
                  <button
                    type="button"
                    name="editLaborDetails"
                    id="editLaborDetails"
                    className="btn btn-secondary mr-2"
                    onClick={handleClick_editLabor}
                    disabled={fetching}
                  >
                    Edit...
                  </button>
                ) : (
                  <button
                    type="button"
                    name="requestLaborUpdate"
                    id="requestLaborUpdate"
                    className="btn btn-secondary mr-2"
                    onClick={(e) => e.preventDefault()}
                    disabled={fetching}
                  >
                    Request Changes...
                  </button>
                ))}
              {!laborDetails.isVerified && !laborDetails.mergedWithLaborId && (
                <button
                  type="button"
                  name="approveLabor"
                  id="approveLabor"
                  className="btn btn-success mr-2"
                  onClick={this.handleClick_verify(laborDetails.hasLinks)}
                >
                  Verify/Merge...
                </button>
              )}
              <button
                type="button"
                name="deleteLabor"
                id="deleteLabor"
                className="btn btn-danger mr-2"
                onClick={this.handleClick_deleteLabor}
                disabled={laborDetails.hasLinks || fetching}
              >
                Delete
              </button>
              {laborDetails.hasLinks && (
                <button
                  type="button"
                  name="laborInUse"
                  id="laborInUse"
                  className="btn btn-link text-muted p-1"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                  In Use
                </button>
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.labors.fetching,
  laborDetails: state.labors.openLaborDetails[ownProps.projectId]
    ? state.labors.openLaborDetails[ownProps.projectId][ownProps.laborId] || null
    : null,
  projLaborList: state.labors.projLaborLists[ownProps.projectId]
    ? state.labors.projLaborLists[ownProps.projectId]
    : null,
});

export default connect(mapStateToProps)(LaborDetails);
